import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './qs-checks-controlling-home.reducer';

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('QsChecksControllingHomePage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getAktuelleVeranstaltung = createSelector(getPageState, (state: PageState) => state.aktuelleVeranstaltung);
export const getPruefplanId = createSelector(getPageState, (state: PageState) => state.pruefplanId);
export const getSaisonIdListe = createSelector(getPageState, (state: PageState) => state.saisonIdListe);
export const getPrueferRollenIds = createSelector(getPageState, (state: PageState) => state.prueferRolleIds);

export const getSaisonUebersicht = createSelector(getPageState, (state: PageState) => state.saisonUebersicht);
export const getSaisonUebersichtLaden = createSelector(getPageState, (state: PageState) => state.saisonUebersichtLaden);
export const getSaisonUebersichtFehler = createSelector(getPageState, (state: PageState) => state.saisonUebersichtFehler);
